export enum MONTHS {
  january = 'january',
  february = 'february',
  march = 'march',
  april = 'april',
  may = 'may',
  june = 'june',
  july = 'july',
  august = 'august',
  september = 'september',
  october = 'october',
  november = 'november',
  december = 'december',
}

export const monthsMap = {
  [MONTHS.january as string]: 0,
  [MONTHS.february as string]: 1,
  [MONTHS.march as string]: 2,
  [MONTHS.april as string]: 3,
  [MONTHS.may as string]: 4,
  [MONTHS.june as string]: 5,
  [MONTHS.july as string]: 6,
  [MONTHS.august as string]: 7,
  [MONTHS.september as string]: 8,
  [MONTHS.october as string]: 9,
  [MONTHS.november as string]: 10,
  [MONTHS.december as string]: 11,
};
